import { GA_MEASUREMENT_ID, analyticsEnabled } from "./config";

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

let initialized = false;

// gtag ровно как в сниппете Google: кладёт в dataLayer объект `arguments`.
// GA4 распознаёт команды только из arguments-объекта; массив он игнорирует.
function ensureGtag() {
  window.dataLayer = window.dataLayer || [];
  if (!window.gtag) {
    const gtag: Window["gtag"] = function () {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer.push(arguments);
    };
    window.gtag = gtag;
  }
}

// Google Consent Mode v2. Тег грузится сразу, но со стартовым состоянием
// «denied»: до согласия GA шлёт только обезличенные пинги без кук, после
// согласия updateAnalyticsConsent переключает на «granted». SPA-навигации
// (History API) GA4 трекает сам через Enhanced measurement.
export function initConsentMode(): void {
  if (initialized || !analyticsEnabled()) return;
  initialized = true;

  ensureGtag();
  window.gtag("consent", "default", {
    ad_storage: "denied",
    analytics_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    wait_for_update: 500,
  });

  const src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  if (!document.querySelector(`script[src="${src}"]`)) {
    const script = document.createElement("script");
    script.async = true;
    script.src = src;
    document.head.appendChild(script);
  }

  window.gtag("js", new Date());
  window.gtag("config", GA_MEASUREMENT_ID);
}

export function updateAnalyticsConsent(granted: boolean): void {
  if (!analyticsEnabled()) return;
  ensureGtag();
  window.gtag("consent", "update", {
    analytics_storage: granted ? "granted" : "denied",
  });
}
